function SidebarNavDivider(props: { children: React.ReactNode[] }) {
    return (
        <div className="py-3">
            <div className="border-b-logo-green border-b-2"></div>
        </div>
    )
}
export default SidebarNavDivider;